Object.defineProperty(exports,"__esModule",{value:true});function emptyFunction(){}var BackHandler={exitApp:emptyFunction,addEventListener:function addEventListener(){return{remove:emptyFunction};},removeEventListener:emptyFunction};exports.default=BackHandler;


// WEBPACK FOOTER //
// ./node_modules/react-native-web/dist/apis/BackHandler/index.js